"use strict";

var _interopRequireDefault = require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCode = getCode;
exports.getMenu = getMenu;
exports.getTicket = getTicket;
exports.getToken = getToken;
exports.getUid = getUid;
exports.getUserName = getUserName;
exports.removeCode = removeCode;
exports.removeMenu = removeMenu;
exports.removeTicket = removeTicket;
exports.removeToken = removeToken;
exports.removeUid = removeUid;
exports.removeUserName = removeUserName;
exports.setCode = setCode;
exports.setMenu = setMenu;
exports.setTicket = setTicket;
exports.setToken = setToken;
exports.setUid = setUid;
exports.setUserName = setUserName;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
/*
 * @Author: Lanren
 * @Date: 2021-08-04 10:14:44
 * @LastEditTime: 2022-03-17 17:26:47
 * @LastEditors: Lanren
 * @Description: ______
 * @FilePath: \sdk-admin\src\utils\auth.js
 * --------
 */

var TokenKey = 'fbtoken';
var UidKey = 'uid';
function getToken() {
  return _jsCookie.default.get(TokenKey) || '';
}
function getTicket() {
  return _jsCookie.default.get('ticket') || '';
}
function getMenu() {
  return localStorage.getItem('menu') || '';
}
function getUserName() {
  return _jsCookie.default.get('username') || '';
}
function setToken(token) {
  return _jsCookie.default.set(TokenKey, token);
}
function setTicket(ticket) {
  return _jsCookie.default.set('ticket', ticket);
}
function setMenu(menu) {
  console.log('in setMenu menu', menu);
  // return localStorage.setItem('menu', JSON.stringify(menu))
}

function setUserName(username) {
  return _jsCookie.default.set('username', username);
}
function removeToken() {
  return _jsCookie.default.remove(TokenKey);
}
function removeTicket() {
  return _jsCookie.default.remove('ticket');
}
function removeMenu() {
  return localStorage.removeItem('menu');
}
function removeUserName() {
  return _jsCookie.default.remove('username');
}
function setUid(id) {
  return _jsCookie.default.set(UidKey, id);
}
function getUid() {
  return _jsCookie.default.get(UidKey);
}
function removeUid() {
  return _jsCookie.default.remove(UidKey);
}
function setCode(code) {
  localStorage.setItem('code', code);
}
function getCode() {
  return localStorage.getItem('code');
}
function removeCode() {
  return localStorage.removeItem('code');
}